import React, { useEffect } from "react";
import Stage from "../../../../components/Stage";

const ThankYouVTPNuevos = () => {

    const [infoNameForm, ] = React.useState("Quiero un auto nuevo");
    const [infoImage, ] = React.useState("form_vtpnuevos.jpg");

    useEffect(() => {
        document.title = "Gracias - Quiero un auto nuevo";
    }, []);

    return (
        <>
            <div className="">
                <Stage title={infoNameForm} img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + infoImage} positionTitle="bottom" />
                <div className="mb-5"></div>
                <section className="container pb-5">
                    <div className="row pt-5">
                        <div className="col-12">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando su solicitud, a la brevedad uno de nuestros asesores se pondrá en contacto con usted para darle seguimiento a su interés de compra.</p>
                            <p className="text-center mt-5 pt-1 mb-5">Para su comodidad y seguridad, le informamos que nos estaremos comunicando desde el número: <strong>222 179 1156</strong>, esto con la finalidad de dar seguimiento a su solicitud y atenderle como lo merece.</p>
                            <div className="text-center mb-5 pb-5">
                                <button className='button-enviar mt-5 mb-5' type='button' onClick={() =>
                                    (window.location = "https://www.audi.com.mx/mx/web/es.html")
                                }>
                                    Ir al Home
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYouVTPNuevos;